<template>
  <v-dialog
    :value="value"
    @input="closeActionsLogModal"
    scrollable
    lazy max-width="600px"
    :persistent="loading"
  >
    <v-card>
      <v-card-title class="headline">{{ $t('message.content.tools.actionsLog.title') }}
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="channelActionsLog"
          :headers="headers"
          hide-actions :total-items="-1">
          <template #items="{ item }">
            <tr @click="selectedVersion = item.id" class="cursor-pointer">
              <td>
                <v-icon
                  v-text="selectedVersion === item.id ? '$vuetify.icons.radioOn' : '$vuetify.icons.radioOff'"
                  :color="selectedVersion === item.id ? 'accent' : 'default'"
                ></v-icon>
              </td>
              <td>{{ item.dateTime | formatDate }}</td>
              <td>
                <v-chip
                  small
                  outline
                  class="nx-primary--lighten-4 nx-text--level-1">
                  <v-avatar size="16px" color="grey lighten-1">
                    <img v-if="item.staff.avatarUrl"
                         :src="item.staff.avatarUrl"
                         :alt="`${item.staff.nick}`">
                    <span v-else>{{ item.staff.name[0] }}</span>
                  </v-avatar>
                  {{ item.staff.nick }}
                </v-chip>
              </td>
            </tr>
          </template>
          <template #no-results>
            <td colspan="3" class="text-xs-center"
                v-html="$t('message.content.tools.actionsLog.contentNotPublishedYet')">
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat
               color="primary"
               @click.native="closeActionsLogModal"
               :disabled="loading" v-html="$t('message.common.close')">
        </v-btn>
        <v-btn
          v-if="form.pristine"
          flat
          color="accent"
          @click="restore"
          :disabled="!selectedVersion"
          :loading="loading">
          {{ $t('message.content.tools.actionsLog.restoreVersion') }}
        </v-btn>
        <v-tooltip top v-else>
          <v-btn
            flat
            color="primary"
            @click="closeActionsLogModal"
            slot="activator">
            Guardar
          </v-btn>
          <span v-html="$t('message.content.tools.actionsLog.mustSaveBeforeRestore')"></span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Storable from '@/mixins/storable';

export default {
  name: 'nx-content-editor-actions-log-tool',
  mixins: [Storable],
  props: {
    value: Boolean,
    editorStorePath: {
      type: [String, Array],
      required: true,
    },
  },
  data() {
    return {
      modalState: false,
      selectedVersion: null,
      loading: false,
      headers: [
        {
          text: 'Selección',
          value: 'selected',
          sortable: false,
        },
        {
          text: 'Fecha de publicación',
          value: 'dateTime',
          sortable: false,
        },
        {
          text: 'Staff',
          value: 'Staff',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    storePath() {
      return this.editorStorePath;
    },
    form() {
      return this.getters.form;
    },
    channelActionsLog() {
      return this.getters.channelActionsLog;
    },
  },
  methods: {
    async closeActionsLogModal() {
      this.$emit('input', false);
      this.selectedVersion = null;
    },
    async restore() {
      if (!this.selectedVersion) {
        return;
      }
      try {
        this.loading = true;
        await this.dispatch('RESTORE_CHANNEL_VERSION', {
          versionId: this.selectedVersion,
        });
      } catch (e) {
        console.error(e);
        this.toast.notify('message.error.serverError');
      } finally {
        this.closeActionsLogModal();
        this.loading = false;
      }
    },
  },
};
</script>
